module.exports = __webpack_public_path__ + "static/media/waterHeater.e2c0cb1b.svg";